import cookie from 'js-cookie';

export const setCookie = (key, value, expires = null) => {
    cookie.set(key, value, {
        expires,
        path: '/'
    });
};

export const removeCookie = key => {
    cookie.remove(key);
};

export const getCookie = key => cookie.get(key);
